//import 'ol/ol.css';
import { Map } from 'ol';
import { ICAMSKey } from '../Shared/Models/UtilityModels';
import { Utilities } from '../Shared/Utility/Utilities';

import * as events from '../Shared/Bus/Bus';

declare var G_IsMobile: Boolean;

export class ReportAnIssueMyIssues {

    // ----------------------------------------------------------- //
    // GLOBAL VARS
    private issueMaxNumberInList: number = 10;
    private issueCountFromServer: number = 0;
    private commentCountFromServer: number = 0;
    private currentPage: number = 0;

    // ----------------------------------------------------------- //

    // ----------------------------------------------------------- //
    //Constructor
    public constructor(protected map: Map) {
        this.initEvents();
        this.initMisc();
    }

    private initEvents = (): void => {
        const self = this;

        // Create lookups
        $('#reportAnIssue_MyIssueCloseBtn').on("click", function () {
            events.bus.publish(events.eventResetAllPanels());
            events.bus.publish(events.eventResetAllButtons(true));
        });

        $('#reportAnIssue_myIssuesShowingNextBtn').on("click", function () {
            self.currentPage++;
            self.loadData(); //reload data
        });
        $('#reportAnIssue_myIssuesShowingPrevBtn').on("click", function () {
            self.currentPage--;
            self.loadData(); //reload data
        });

        //filter & sort
        $('#myIssuesFilter select').on('change', function () {
            self.currentPage = 0;
            self.loadData(); //reload data
        });

        function isNumber(value: string | number): boolean {
            return ((value != null) &&
                (value !== '') &&
                !isNaN(Number(value.toString())));
        }

        // My issues radio button
        $('#reportAnIssue_MyIssueOption').on('change', function () {
            self.resetPage();
            self.loadIssuesIntoPanel();
        });

        $('#reportAnIssue_MyCommentsOption').on('change', function () {
            self.resetPage();
            self.loadCommentsIntoPanel();
        });
    }

    private initMisc = (): void => {

    }

    // ----------------------------------------------------------- //
    // Open Panels
    public openMyIssuesPanel = (): void => {
        this.currentPage = 0;
        $("#reportAnIssue_MyCommentsOption").prop('checked', false);
        $("#reportAnIssue_MyIssueOption").prop('checked', true);
        $("#reportAnIssue_MyCommentsOption").parent().removeClass('active');
        $("#reportAnIssue_MyIssueOption").parent().addClass('active');

        this.loadData();
        // Also make sure we manually get the count for comments
        this.getCommentsCount(null);

        $('#reportAnIssueMyIssuesPanel').addClass('show');
    }

    public loadData = (): void => {
        const self = this;
        if ($('#reportAnIssue_MyCommentsOption').is(":checked") == true) {
            self.loadCommentsIntoPanel();
        } else {
            self.loadIssuesIntoPanel();
        }
    }

    // ----------------------------------------------------------- //
    // Get ISSUE data from server
    private loadIssuesIntoPanel = (): void => {
        // Get the data from the server
        const self = this;

        let skip = self.currentPage * self.issueMaxNumberInList;
        let take = self.issueMaxNumberInList;
        let viewName = <string>$('#myIssuesFilter select').children("option:selected").val();

        // Hide the filter
        $('#myIssuesFilter').show();

        // Get the issue count
        self.getIssueCount(viewName);
      
        Utilities.BlockUI($('#reportAnIssueMyIssuesPanel'));
        $('#reportAnIssueMyIssuesResults').load(window.G_SITEFOLDERNAME +'/ReportAnIssue/ReportAnIssueMyIssues', { viewName: viewName, skip: skip, take: take }, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI($('#reportAnIssueMyIssuesPanel'));
            // Update UI
            self.updatePagingUI();

            // Bind buttons
            $('[data-zoommap]').on("click", function () {
                const data: ICAMSKey = $(this).data("zoommap");
                events.bus.publish(events.eventZoomToAnyFeature([data, true, null]));

                if (G_IsMobile == true) {
                    setTimeout(function () {
                        events.bus.publish(events.eventResetAllPanels());
                        events.bus.publish(events.eventResetAllButtons(true));
                    }, 300);
                }
            });

            // Show issue comments
            $('[data-comment]').on("click", function () {
                const data: ICAMSKey = $(this).data("comment");
                events.bus.publish(events.eventOpenMaintCommentCreatePanel(data));
            });

            //Get any associated image from Librarylink
            $('[name="reportAnIssueMyIssuesPhotoContainer"]').each(function (index, element) {
                var myEl = $(this);
                events.bus.publish(events.eventPhotoCreatePhotoThumbnail([element, function (r) { if (r == true) myEl.css("display", "none"); }]));
            });
        });
    }

    private getIssueCount = (viewName: string): void => {
        // Get the data from the server
        const self = this;
        $.post(`/ReportAnIssue/GetMyIssuesCount`, { viewName: viewName }, function (response) {
            try {
                self.issueCountFromServer = JSON.parse(response);
                $('#reportAnIssueMyIssuesCount').html(' (' + self.issueCountFromServer + ')');
            }
            catch (e) {
                console.log("Error getting issue data: /ReportAnIssue/GetMyIssuesCount");
                console.log(e);
            }
        }).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    // ----------------------------------------------------------- //
    // Get COMMENT data from server
    private loadCommentsIntoPanel = (): void => {
        // Get the data from the server
        const self = this;

        let skip = self.currentPage * self.issueMaxNumberInList;
        let take = self.issueMaxNumberInList;

        // Get the issue count
        self.getCommentsCount(null);

        // Hide the filter
        $('#myIssuesFilter').hide();

        Utilities.BlockUI($('#reportAnIssueMyIssuesPanel'));
        $('#reportAnIssueMyIssuesResults').load(window.G_SITEFOLDERNAME +'/ReportAnIssue/ReportAnIssueMyComments', { viewName: null, skip: skip, take: take }, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI($('#reportAnIssueMyIssuesPanel'));

            $('[data-zoommap]').on("click", function () {
                const data: ICAMSKey = $(this).data("zoommap");
                events.bus.publish(events.eventZoomToAnyFeature([data, true, null]));
            });

            $('[data-comment]').on("click", function () {
                var data = $(this).data("comment");
                events.bus.publish(events.eventOpenMaintCommentCreatePanel(data));
            });

            // Update UI
            self.updatePagingUI();
        });
    }

    private getCommentsCount = (viewName: string): void => {
        // Get the data from the server
        const self = this;
        $.post(`/ReportAnIssue/GetMyComments_Count`, { viewName: viewName }, function (response) {
            try {
                self.commentCountFromServer = JSON.parse(response);
                $('#reportAnIssueMyCommentsCount').html(' (' + self.commentCountFromServer + ')');
            }
            catch (e) {
                console.log("Error getting issue data: /ReportAnIssue/GetMyComments_Count");
                console.log(e);
            }
        }).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    // ----------------------------------------------------------- //
    // MISC
    private resetPage = (): void => {
        const self = this;
        self.currentPage = 0;
        self.updatePagingUI();
    }

    private updatePagingUI = (): void => {
        const self = this;
        if (self.currentPage > 0) $('#reportAnIssue_myIssuesShowingPrevBtn').show(); else $('#reportAnIssue_myIssuesShowingPrevBtn').hide();
        $('#myIssuesShowing').html('Showing ' + (self.currentPage * self.issueMaxNumberInList + 1) * 1 + ' to ' + ((self.currentPage * self.issueMaxNumberInList) + self.issueMaxNumberInList) * 1);

        if ($('#reportAnIssue_MyCommentsOption').is(":checked") == true) {
            $("#reportAnIssue_MyIssueOption").parent().removeClass('active');
            $("#reportAnIssue_MyCommentsOption").parent().addClass('active');
            if (self.currentPage <= Math.trunc(self.commentCountFromServer / self.issueMaxNumberInList) - 1) $('#reportAnIssue_myIssuesShowingNextBtn').show(); else $('#reportAnIssue_myIssuesShowingNextBtn').hide();
        } else {
            $("#reportAnIssue_MyIssueOption").parent().addClass('active');
            $("#reportAnIssue_MyCommentsOption").parent().removeClass('active');
            if (self.currentPage <= Math.trunc(self.issueCountFromServer / self.issueMaxNumberInList) - 1) $('#reportAnIssue_myIssuesShowingNextBtn').show(); else $('#reportAnIssue_myIssuesShowingNextBtn').hide();
        }
        
    }
} 
